export default __webpack_public_path__ + "static/media/rightArrow.4a1b7f3e.svg";